import axios from 'axios';
import type {
  AgentAccessAgent,
  AgentAccessConnection,
  AgentAccessPermission,
} from '../models/agentAccessTypes';

// POST /AgentAccess/lookup also exists, for resolving an unlisted publisher by address. It has no
// caller here: adding an unverified agent is a LeanLaw-operations action for now, not a self-serve one.
const BASE = '/AgentAccess';

export default {
  async fetchAgents(): Promise<AgentAccessAgent[]> {
    const { data } = await axios.get(BASE);
    return data;
  },

  async fetchPermissions(): Promise<AgentAccessPermission[]> {
    const { data } = await axios.get(`${BASE}/permissions`);
    return data;
  },

  async fetchConnections(): Promise<AgentAccessConnection[]> {
    const { data } = await axios.get(`${BASE}/connections`);
    return data;
  },

  async approve(clientId: string, allowedScopes: string[] | null): Promise<AgentAccessAgent> {
    const { data } = await axios.post(`${BASE}/approve`, { clientId, allowedScopes });
    return data;
  },

  async withdraw(clientId: string): Promise<AgentAccessAgent> {
    const { data } = await axios.post(`${BASE}/withdraw`, { clientId });
    return data;
  },

  async restore(clientId: string): Promise<AgentAccessAgent> {
    const { data } = await axios.post(`${BASE}/restore`, { clientId });
    return data;
  },

  async revokeConnection(grantId: string): Promise<void> {
    await axios.delete(`${BASE}/connections/${grantId}`);
  },
};
